// extracted by mini-css-extract-plugin
module.exports = {"cartIconWrapper":"CartIcon_cartIconWrapper__Hdxg3","itemCount":"CartIcon_itemCount__3P-qU"};